<div class="modal-content">
    <a class="btn-flat right" onclick="closeModalWithID('filtermodal')">
        <i class="material-icons large">close</i>
    </a>
    <h4 class="action-color">Filter</h4>
    
    <div class="row" *ngIf="filterValues.length > 0">
        <div class="col s12">
            <p>Aktive Filter:</p>
            <div class="chip" *ngFor="let filterValue of filterValues" style="margin-right: 8px; margin-bottom: 8px;">
                {{filterValue.filterLabel()}}
                <i class="material-icons" (click)="onDeleteFilter(filterValue)">close</i>
            </div>
            <p class="grey-text" *ngIf="filterMatchCount > 0">
                {{filterMatchCount}} Aufträge entsprechen den ausgewählten Filtern
            </p>
        </div>
    </div>

    <div class="row">
        <div class="input-field col s12">
            <select id="inputFilterStatus" class="inputFilterStatus browser-default" (change)="onStatusChange($event)">
                <option value="0" selected>Status wählen</option>
                <option *ngFor="let filterInputContractName of filterInputContractNames" 
                        value="{{filterInputContractName}}">
                    {{filterInputContractName}}
                </option>
            </select>
        </div>
    </div>

    <div class="row">
        <div class="input-field col s11">
            <input id="inputFilterEntry" type="text" placeholder="tt.mm.yyyy" class="inputFilterEntry" maxlength="10" 
                   (keyup.enter)="onAddFilter('Entry')">
            <label id="inputFilterEntryLabel" for="inputFilterEntry" class="inputFilterEntryLabel active">
                Eingangsdatum
            </label>
        </div>
        <div class="input-field col s1">
            <i class="material-icons redesign action cursor-pointer" style="margin-top: 10px;"
               (click)="onAddFilter('Entry')">add</i>
        </div>
    </div>

    <div class="row">
        <div class="input-field col s11">
            <input id="inputFilterBurial" type="text" placeholder="tt.mm.yyyy" class="inputFilterBurial" maxlength="10"
                   (keyup.enter)="onAddFilter('Burial')">
            <label id="inputFilterBurialLabel" for="inputFilterBurial" class="inputFilterBurialLabel active">
                Einäscherungsdatum
            </label>
        </div>
        <div class="input-field col s1">
            <i class="material-icons redesign action cursor-pointer" style="margin-top: 10px;"
               (click)="onAddFilter('Burial')">add</i>
        </div>
    </div>

    <div class="row">
        <div class="input-field col s12">
            <span class="left">
                <i class="material-icons redesign action" (click)="onClearFilters()">delete</i>
            </span>
        </div>
    </div>
</div> 